import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getDict } from '@/utils/dictionary';
import { toLowerCase, toSQLLine } from '@/utils/stringFun';
import { getSysDictionaryList } from '@/api/sysDictionary';
export default {
  name: 'FieldDialog',
  props: {
    dialogMiddle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dbfdOptions: [],
      dictOptions: [],
      typeSearchOptions: [{
        label: '=',
        value: '='
      }, {
        label: '<>',
        value: '<>'
      }, {
        label: '>',
        value: '>'
      }, {
        label: '<',
        value: '<'
      }, {
        label: 'LIKE',
        value: 'LIKE'
      }],
      typeOptions: [{
        label: '字符串',
        value: 'string'
      }, {
        label: '整型',
        value: 'int'
      }, {
        label: '布尔值',
        value: 'bool'
      }, {
        label: '浮点型',
        value: 'float64'
      }, {
        label: '时间',
        value: 'time.Time'
      }],
      rules: {
        fieldName: [{
          required: true,
          message: '请输入field英文名',
          trigger: 'blur'
        }],
        fieldDesc: [{
          required: true,
          message: '请输入field中文名',
          trigger: 'blur'
        }],
        fieldJson: [{
          required: true,
          message: '请输入field格式化json',
          trigger: 'blur'
        }],
        columnName: [{
          required: true,
          message: '请输入数据库字段',
          trigger: 'blur'
        }],
        fieldType: [{
          required: true,
          message: '请选择field数据类型',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var dictRes;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getSysDictionaryList({
                page: 1,
                pageSize: 999999
              });

            case 2:
              dictRes = _context.sent;
              _this.dictOptions = dictRes.data.list;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    autoFill: function autoFill() {
      this.dialogMiddle.fieldJson = toLowerCase(this.dialogMiddle.fieldName);
      this.dialogMiddle.columnName = toSQLLine(this.dialogMiddle.fieldJson);
    },
    getDbfdOptions: function getDbfdOptions() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.dialogMiddle.dataType = '';
                _this2.dialogMiddle.dataTypeLong = '';
                _this2.dialogMiddle.fieldSearchType = '';
                _this2.dialogMiddle.dictType = '';

                if (!_this2.dialogMiddle.fieldType) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 7;
                return getDict(_this2.dialogMiddle.fieldType);

              case 7:
                _this2.dbfdOptions = _context2.sent;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};